import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import {NavigationEnd, NavigationStart, Router, RoutesRecognized} from "@angular/router";
import { filter, first, map, mapTo, mergeMap } from "rxjs/operators";

import { AppConfig, AuthService } from "./core";
import { isLanternRoute } from "./pages";

@Component({
  selector: "ta-lantern-app",
  encapsulation: ViewEncapsulation.None,
  template: `
    <mat-progress-bar *ngIf="showProgressBar" mode="indeterminate"></mat-progress-bar>
    <router-outlet></router-outlet>
  `
})
export class LanternAppComponent implements OnInit {
  private lanternRoutes$ = this.router.events.pipe(
    filter((event) => event instanceof RoutesRecognized),
    map((event) => (event as RoutesRecognized).url),
    filter(isLanternRoute),
    mergeMap((routeUrl) => {
      return this.auth.onInitialized.pipe(first(), mapTo(routeUrl));
    })
  );

  showProgressBar = false;

  constructor(
    private app: AppConfig,
    private auth: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (this.app.auth.martAuth) {
      this.initAppAuthCheck();
    }

    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(() => {
        this.showProgressBar = true;
      });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.showProgressBar = false;
      });
  }

  private initAppAuthCheck(): void {
    this.lanternRoutes$.subscribe((currentRoute) => {
      if (this.auth.martJwt == null) {
        this.router.navigateByUrl(`/go-login?redirect=${currentRoute}`);
      } else if (
        this.app.auth.appAuthCheck &&
        !this.auth.hasApplication(this.app.name)
      ) {
        this.router.navigateByUrl("/no-permission");
      }
    });
  }
}
